document.addEventListener('DOMContentLoaded', function() {
  var buttons = document.querySelectorAll('.js-accordion-trigger');
  buttons.forEach(function(button) {
    var heading = button.querySelector('span.h6');
    if (heading && heading.textContent.trim() === 'Product Features') {
      var contentId = button.getAttribute('aria-controls');
      var content = document.getElementById(contentId);
      if (content) {
        setTimeout(function() {
          content.style.setProperty('max-height', '2000px', 'important');
          content.style.setProperty('overflow', 'visible', 'important');
        }, 300);
      }
    }
  });
});